<template>
  <div class="text-fix">
    <page-header :page="pageOptions" :actions="headerActionConfig" />
    <div v-if="registries.length == 0" class="mt-4">
      <div class="col-12 d-flex mt-4 p-4">
        <div class="col-12 text-center align-items-center">
          <img
            src="@/assets/img/regular-unlink.svg"
            alt="regular-unlink"
            class="img-box text-center"
          />
        </div>
      </div>
      <div class="col-12 text-center empty-registry-text">
        <span>
          Actualmente no existe ningún registro para este estudiante.
          <br />
        </span>
        <span>
          <b>Para crear un registro, favor de oprimir el botón de añadir.</b>
        </span>
      </div>
    </div>

    <div v-for="(item, idx) in registries" :key="idx">
      <section-title
        class="mb-4"
        bg-icon="green"
        icon="fas fa-file-alt green"
        :content="`Año Escolar ${item[0].academicYearDesc}`"
        reverse
      />

      <HistoryItem
        v-for="detail in item"
        :key="detail.createDate"
        :detail="detail"
        :form-types="formTypes"
        @deleteHistoryItem="deleteHistoryItem"
      />
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import { createNamespacedHelpers } from 'vuex';
const { mapMutations } = createNamespacedHelpers('$_student');
import HistoryItem from '@/components/student/registry/HistoryItem.vue';
import alert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import StudentStatuses from '@/utils/constants/reg/studentStatuses';
import EnumStudentStatuses from '@/utils/constants/student/studentStatuses';
import commentTypes from '@/utils/constants/comment/commentTypes';
import codeViewTypes from '@/utils/constants/comment/CodeViewTypes.js';
import { SectionTitle } from '@/components/pei/shared';
import PageHeader from '@/components/common/page/PageHeader';
import commentsStore from '@/views/comments/comments-store';

const MODULES = {
  STUDENT: "e2ab3f04-b958-4755-8a1b-da0b75920104"
};
const GET_STUDENT_REG_HISTORY = 'api/studentregistry/history/';
const GET_REG_STUDENT_HAS_PENDING_APPOINTMENTS =
  '/api/appointment/hasPendingAppointments/';
const GET_REG_STUDENT_CAN_INACTIVATE =
  'api/student/ValidateStudentCanBeInactivated/';
const GET_REG_STUDENT_IN_EDUCATIONAL_COMPENSATORY_SERVICES =
  'api/student/ValidateStudentInEducationalCompensatoryServices/';

export default {
  name: 'Registry',
  mixins: [alert],
  components: {
    PageHeader,
    HistoryItem,
    SectionTitle,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-clipboard-user',
        title: 'Registro del Estudiante',
        routes: ['Estudiante', 'Registro del Estudiante'],
      },
      registries: [],
      resources: [],
      isStudentInactivable: false,
      isStudentInEducationalCompensatoryServices: false,
      formTypes: [],
    };
  },
  methods: {
    ...mapMutations(['setSelectedStudentStatus']),
    goToAddRegistration() {
      this.$router.push({ path: '/student/registrygeneral' });
    },
    changeStatusToRegistry() {
      this.ShowCancelModal(
        this.resources['R90005'],
        this.resources['R16007'],
        this.resources['R90007'],
        this.resources['R90008']
      ).then(async (answer) => {
        if (answer) {
              commentsStore.commit('setSelectedCategory',commentTypes.Registro);
              commentsStore.commit('setSelectedModule', MODULES.STUDENT);
              this.$router.push({
                name: 'studentAddComment',
                params: {
                isReadOnly: true,
                commentId: null,
                commentDate: new Date(),
                commentCategoryTypeId: commentTypes.Registro,
              },
            });
        }
      });
    },
    // Get student registry history.
    async getHistory() {
      let self = this;
      this.registries = [];
      return await new Promise((resolve) => {
        self
          .$ApiGet(GET_STUDENT_REG_HISTORY + this.selectedStudent.studentId)
          .then((res) => {
            let grouped = Object.values(
              this.$groupBy(res.data.data, (c) => c.academicYearId)
            );

            function compareOrder(a, b) {
              if (a[0].academicYearId > b[0].academicYearId) return -1;
              if (b[0].academicYearId > a[0].academicYearId) return 1;
              return 0;
            }

            self.registries = grouped.sort(compareOrder);
            store.commit('SetPreregisterFlag', self.registries);
            if (self.registries.length > 0) {
              let studentRegistry = self.registries[0];
              this.validateStudentCanBeInactivated(studentRegistry.statusDesc);
            }
            resolve(res.data);
          })
          .catch(() => {
            self.ShowToast('Error', this.resources['R03200108'], 'error');
          });
      });
    },
    async getFormTypes() {
      let self = this;
      self
        .$ApiGet('api/code/registryformtypes')
        .then((response) => {
          self.formTypes = response.data;
        })
        .catch((errm) => {
          self.ShowToast('', errm.message, 'error');
        });
    },
    async deleteHistoryItem() {
      await this.getHistory();
      this.ShowToast('Notificación', this.resources['R03200147'], 'success');
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200147',
        'R03200108',
        '22087',
        'R16007',
        'R90005',
        'R90008',
        'R90007',
        'R16008',
      ]);
    },
    inactivateStudentRegistry() {
      let self = this;
      self
        .$ApiGet(
          GET_REG_STUDENT_HAS_PENDING_APPOINTMENTS +
            this.selectedStudent.studentId
        )
        .then((result) => {
          let hasPendingAppointments = result.data;
          if (hasPendingAppointments) {
            self.ShowToast('Aviso', self.resources['22087'], 'warning');
          } else {
            self
              .ShowCancelModal(
                'Confirmación',
                '¿Está seguro que quiere inactivar este estudiante?',
                'Si',
                'No'
              )
              .then(function(response) {
                if (response) {
                  commentsStore.commit('setSelectedCategory',commentTypes.RegistroComentarioInactividad);
                  commentsStore.commit('setSelectedModule', MODULES.STUDENT);
                  self.$router.push({
                    name: 'studentAddComment',
                    params: {
                      isReadOnly: true,
                      commentId: null,
                      commentDate: new Date(),
                      commentCategoryTypeId:
                        commentTypes.RegistroComentarioInactividad,
                      codeViewTypeId: codeViewTypes.InactivarEstudiante,
                    },
                  });
                }
              });
          }
        })
        .catch(() => {
          'Error', this.resources['R03200108'], 'error';
        });
    },
    async validatePostRegister() {
      let self = this;
      await self.onPostRegister();
    },
    reactivateStudentRegistry() {
      let self = this;
      self
        .ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea Re-Activar el estudiante seleccionado?',
          'Si',
          'No'
        )
        .then(function(response) {
          if (response) {
            self.$router.push({
              name: 'studentAddComment',
              params: {
                isReadOnly: true,
                commentId: null,
                commentDate: new Date(),
                commentCategoryTypeId: commentTypes.RegistroReactivacion,
                codeViewTypeId: codeViewTypes.ReactivarEstudiante,
              },
            });
          }
        })
        .catch(() => {
          'Error', this.resources['R03200108'], 'error';
        });
    },
    validateStudentCanBeInactivated(status) {
      if (status == undefined || status == null) {
        status = this.selectedStudent.status;
      }

      switch (status) {
        case StudentStatuses.PreRegistro:
          this.validateStudentInPreRegistryCanBeInactivated();
          break;
        case StudentStatuses.Registro:
        case StudentStatuses.Evaluado:
          this.isStudentInactivable = true;
          break;
        case StudentStatuses.Inactivo:
          this.isStudentInactivable = false;
          break;
      }
    },

    validateStudentInPreRegistryCanBeInactivated() {
      let self = this;

      self
        .$ApiGet(
          GET_REG_STUDENT_CAN_INACTIVATE + this.selectedStudent.studentId
        )
        .then((result) => {
          this.isStudentInactivable = result.data;
        })
        .catch(() => {
          self.ShowToast('Error', this.resources['R03200108'], 'error');
        });
    },
    async validateStudentInEducationalCompensatoryServices() {
      await this.$ApiGet(
        GET_REG_STUDENT_IN_EDUCATIONAL_COMPENSATORY_SERVICES +
          this.selectedStudent.studentId
      )
        .then((result) => {
          this.isStudentInEducationalCompensatoryServices = result.data;
        })
        .catch(() => {
          self.ShowToast('Error', this.resources['R03200108'], 'error');
        });
    },

    async onPostRegister() {
      const answer = await alert.methods.ShowCancelModal(
        'Alerta',
        '¿Está seguro que desea crear un nuevo Post-Registro para el estudiante seleccionado?',
        'Sí',
        'No'
      );
      if (answer) {
        const wantToCreateEvaluation = await alert.methods.ShowCancelModal(
          'Alerta',
          '¿Es necesario realizarle las evaluaciones correspondientes?',
          'Sí',
          'No'
        );
        const selectedStudent = this.selectedStudent;
        const data = {
          regStudentId: selectedStudent.regStudentId,
          studentSieId: parseInt(selectedStudent.studentId),
          initialDescription: 're-post-registry',
          hasInitialEvaluationFlag: !wantToCreateEvaluation ? '1' : '0', //"0"
        };
        const { data: postRegistryResponse } = await this.$ApiPost(
          '/api/studentregistry/createpostregistry',
          data
        );
        this.$emit('set-disability', [6]);

        if (postRegistryResponse.studentStatus === EnumStudentStatuses.Registro)
          this.setSelectedStudentStatus(StudentStatuses.Registro);

        await this.getHistory();
      }
    },
    async setToEvaluated() {
      await this.$ApiPost(
        `/api/studentregistry/setStudentToEvaluated/${this.studentSieId}`
      );
      await this.getHistory();
      this.setSelectedStudentStatus(StudentStatuses.Evaluado);
      this.selectedStudent.statusId = StudentStatuses.Evaluado;
    },
    goToStudentHome() {
      this.$router.push({ path: '/student' });
    },
    activateStudentRegistry() {
      let self = this;
      self
        .ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea Re-Activar el estudiante seleccionado?',
          'Si',
          'No'
        )
        .then(function(response) {
          if (response) {
            self.$router.push({
              name: 'studentAddComment',
              params: {
                isReadOnly: true,
                commentId: null,
                commentDate: new Date(),
                commentCategoryTypeId: commentTypes.Registro,
                codeViewTypeId: codeViewTypes.AnadirComentario,
              },
            });
          }
        })
        .catch(() => {
          'Error', this.resources['R03200108'], 'error';
        });
    },
    async refreshStudentInfo(){
      await store.dispatch("$_student/refreshStudentMainInfo");
    }
  },
  computed: {
    showActionButtons() {
      return this.selectedStudent?.statusId != EnumStudentStatuses.Servido;
    },
    pageOptions() {
      return {
        title: 'Registro del Estudiante',
        icon: 'fas fa-user-tie',
        routes: ['Estudiante', 'Registro del Estudiante'],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.goToStudentHome();
          },
          visible: true,
        },
        {
          text: 'Evaluado',
          icon: 'fas fa-clipboard-check',
          variant: 'success',
          click: this.setToEvaluated,
          visible: this.canChangeToEvaluated && this.registries.length > 0 && this.showActionButtons,
        },
        {
          text: 'Registro',
          icon: 'fas fa-clipboard-user',
          variant: 'outline-success',
          click: this.changeStatusToRegistry,
          visible: this.canChangeToRegistered && this.registries.length > 0 && this.showActionButtons,
        },
        {
          text: 'Inactivar',
          icon: 'fas fa-times-circle',
          variant: 'outline-danger',
          click: this.inactivateStudentRegistry,
          visible:
            this.isStudentInactivable &&
            this.registries.length > 0 &&
            store.getters.HasPermission('student.registry.inactivate'),
        },
        {
          text: 'Re-Activar',
          icon: 'fas fa-times-circle',
          variant: 'outline-success',
          click: this.reactivateStudentRegistry,
          visible:
            this.isStudentReActivable &&
            this.registries.length > 0 &&
            store.getters.HasPermission('student.registry.reactivate'),
        },
        {
          text: 'Post-Registro',
          icon: 'fas fa-file-user',
          variant: 'success',
          click: this.validatePostRegister,
          visible: this.CanCreatePostRegistry && this.registries.length > 0,
        },
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.goToAddRegistration,
          visible: this.registries.length == 0,
        },
      ];
    },
    isStudentReActivable() {
      if (this.selectedStudent != null) {
        let status = this.selectedStudent.status;
        switch (status) {
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    studentStatus() {
      if (this.selectedStudent != null) {
        return this.selectedStudent.status;
      } else return null;
    },
    CanCreatePostRegistry() {
      let status = this.studentStatus;
      let result = false;
      switch (status) {
        case StudentStatuses.NoElegible:
        case StudentStatuses.Egreso:
        case StudentStatuses.Inactivo:
          result = true;
          break;
        default:
          break;
      }

      return (
        result &&
        store.getters.HasPermission('student.registry.allowcreatepostregistry')
      );
    },
    selectedStudent() {
      return this.$store.getters['$_student/SelectedStudent'];
    },
    selectedStudentStatus() {
      return this.selectedStudent.statusId;
    },
    canChangeToEvaluated() {
      return (
        (this.selectedStudentStatus == EnumStudentStatuses.NoElegible ||
          this.selectedStudentStatus == EnumStudentStatuses.Elegible ||
          this.selectedStudentStatus == EnumStudentStatuses.Servido) &&
        store.getters.HasPermission('registry.changeto.evaluated')
      );
    },
    canChangeToRegistered() {
      let currentStudentStatusId = this.selectedStudent.statusId;

      return (
        (currentStudentStatusId == EnumStudentStatuses.NoElegible ||
          currentStudentStatusId == EnumStudentStatuses.Elegible ||
          currentStudentStatusId == EnumStudentStatuses.Servido ||
          currentStudentStatusId == EnumStudentStatuses.Evaluado) &&
        store.getters.HasPermission('registry.statusto.registered')
      );
    },
    studentSieId() {
      return parseInt(this.selectedStudent.studentId);
    },
  },
  async mounted() {
    await this.refreshStudentInfo();
    this.loadResources();
    await this.getHistory();
    await this.getFormTypes();
    await this.validateStudentInEducationalCompensatoryServices();
  },
};
</script>

<style scoped>
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}
.header {
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.text-fix {
  font-weight: 400;
}
.registry-status {
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 26px;
  opacity: 1;
  width: 189px;
  height: 37px;
}
.state-green {
  background: #a3e5b3;
}
.state-yellow {
  background: #f8eb7f;
}
.state-red {
  background: #fcc9c8;
}
.row-odd {
  background-color: #fafbfa;
}
.row-even {
  background-color: #ffffff;
}
.btn-green {
  border: 1px solid #2db782;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-item {
  font: Regular 16px/19px Lato;
}
.dropdown-item i {
  margin-right: 1rem;
}
.empty-registry-text {
  color: #727272;
}
</style>
